import styled from "@rentiohq/web-theme";
import { RM_COLORS } from "../../rentmatch.colors";

export const ToolbarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing("base")};
  padding: ${({ theme }) => theme.spacing("tight")}
    ${({ theme }) => theme.spacing("loose")};
  margin: 0 -${({ theme }) => theme.spacing("loose")};
  width: calc(100% + ${({ theme }) => `2 * ${theme.spacing("loose")}`});
  background: ${({ theme }) => theme.colors.neutral10};
`;

export const SearchInputWrapper = styled.div`
  position: relative;
  flex: 1;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 48px;
  padding: 0 12px 0 40px;
  box-sizing: border-box;
  border: 1px solid ${RM_COLORS.grayMuted};
  border-radius: 4px;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.neutral100};
  background: ${RM_COLORS.white};
  outline: none;
  transition:
    border-color 250ms ease-in,
    box-shadow 150ms ease-in;

  &::placeholder {
    color: ${({ theme }) => theme.getColor("gray", 400)};
  }

  &:focus {
    border-color: ${RM_COLORS.grayMuted};
    box-shadow: 0 0 0 2px rgba(167, 169, 171, 0.25);
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.getColor("gray", 400)};
  pointer-events: none;
  display: flex;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ToolbarSpacer = styled.div`
  flex: 1;
`;

export const ToolbarDivider = styled.div`
  width: 1px;
  height: 24px;
  background: ${({ theme }) => theme.colors.neutral80};
  opacity: 0.15;
  flex-shrink: 0;
  align-self: center;
`;

export const ToolbarInlineItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing("tight")};
  flex-shrink: 0;
  white-space: nowrap;

  button {
    background-color: ${({ theme }) => theme.colors.neutral0};
  }
`;

// No forced button background here: the filter button controls its own
// background via its Button appearance (green/primary when a filter is active,
// outline otherwise). A blanket background-color would override the active
// green and make the button look inactive.
export const ToolbarFilterWrap = styled.div``;
